var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{attrs:{"header":_vm.$t('currentListOfOffers')}},[_c('OfferListDataTable',{attrs:{"header":_vm.$t('displayedOnYourWebsite'),"items":_vm.fetchDataIn}}),_c('OfferListDataTable',{attrs:{"header":_vm.$t('notDisplayedOnYourWebsite'),"items":_vm.fetchDataNotIn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }